import { render, staticRenderFns } from "./EntityCompare.vue?vue&type=template&id=2521d0a4&scoped=true"
import script from "./EntityCompare.vue?vue&type=script&lang=js"
export * from "./EntityCompare.vue?vue&type=script&lang=js"
import style0 from "./EntityCompare.vue?vue&type=style&index=0&id=2521d0a4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2521d0a4",
  null
  
)

export default component.exports